module.exports = function() {
  return new Worker(__webpack_public_path__ + "00bd1c4217b90f12d4c4.worker.js");
};